import { Model } from 'pinia-orm';
import { BelongsTo, Num, Str } from 'pinia-orm/dist/decorators';
import ScopeGap from './ScopeGap';
import ScopeGapCategory from './ScopeGapCategory';
import ScopeGapItem from './ScopeGapItem';
/* --- user header --- */
/* --- end user header --- */

export default class MonthlyScopeGapForecast extends Model {
  static entity = 'App\\Models\\MonthlyScopeGapForecast';
  // fields
  @Num(0)
  declare id: number;
  @Num(0)
  declare scope_gap_id: number;
  @Num(0)
  declare scope_gap_item_id: number;
  @Num(0)
  declare forecast_amount: number;
  @Num(0)
  declare sort_order: number;
  @Num(undefined)
  declare scope_gap_category_id: number | null;
  @Str('')
  declare created_at: string;
  @Str('')
  declare updated_at: string;
  // relations
  @BelongsTo(() => ScopeGap, 'scope_gap_id', 'id')
  declare scope_gap: ScopeGap;
  @BelongsTo(() => ScopeGapItem, 'scope_gap_item_id', 'id')
  declare scope_gap_item: ScopeGapItem;
  @BelongsTo(() => ScopeGapCategory, 'scope_gap_category_id', 'id')
  declare scope_gap_category: ScopeGapCategory;
  /* --- user code --- */

  /* --- end user code --- */
}
